import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-previous",
  "use": "icon-previous-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-previous\"><defs><style></style></defs><path d=\"M256 256h85.333v512H256V256zm149.333 256L768 768V256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol